import { render, staticRenderFns } from "./AccessibilityPolicy.vue?vue&type=template&id=039e11b1"
import script from "./AccessibilityPolicy.vue?vue&type=script&lang=js"
export * from "./AccessibilityPolicy.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityPolicy.vue?vue&type=style&index=0&id=039e11b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports